// extracted by mini-css-extract-plugin
module.exports = {"qty":"CartItemCard_qty__H__j3","btnRemoveError":"CartItemCard_btnRemoveError__5FPEI","btnRemove":"CartItemCard_btnRemove__9bbAb"};